"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransitionStyles = void 0;
var transitions_1 = require("../transitions");
var transitionStatuses = {
    entering: 'in',
    entered: 'in',
    exiting: 'out',
    exited: 'out',
};
function getTransitionStyles(_a) {
    var transition = _a.transition, state = _a.state, duration = _a.duration, timingFunction = _a.timingFunction;
    var shared = {
        transitionDuration: duration + "ms",
        transitionTimingFunction: timingFunction,
    };
    if (typeof transition === 'string') {
        if (!(transition in transitions_1.transitions)) {
            return null;
        }
        return __assign(__assign(__assign({ transitionProperty: transitions_1.transitions[transition].transitionProperty }, shared), transitions_1.transitions[transition].common), transitions_1.transitions[transition][transitionStatuses[state]]);
    }
    return __assign(__assign(__assign({ transitionProperty: transition.transitionProperty }, shared), transition.common), transition[transitionStatuses[state]]);
}
exports.getTransitionStyles = getTransitionStyles;
